export const leadsListConfig = {
    tableHeader: [
        { key: 'leadSource' },
        { key: 'status' },
        { key: 'leadCreationTimestamp', width: '250px' },
        { key: 'contractId' },
        { key: 'armadaCustomerId' },
        { key: 'leasmanCustomerId' },
        { key: 'companyName' },
        { key: 'customerFullName' },
        { key: 'customerType' },
        { key: 'customerEmail' },
        { key: 'leadId', width: '300px' },
    ],
};
